import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useGoogleMap } from '@react-google-maps/api'

/* global google */

/**
 * Loads google maps place based on place ID.
 * @param placeId Google maps Place ID
 * @returns {[place, loading]}
 */
const usePlace = ({ placeId }) => {
    const map = useGoogleMap()
    const [loading, setLoading] = useState(false)
    const [place, setPlace] = useState(false)

    useEffect(() => {
        if (placeId) {
            const request = {
                placeId,
                // fields,
                language: 'fi',
            }

            const service = new google.maps.places.PlacesService(map)
            service.getDetails(request, (place, status) => {
                setLoading(false)

                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    setPlace(place)
                } else {
                    setPlace(null)
                }
            })

            setLoading(true)
            setPlace(null)
        } else {
            setLoading(false)
            setPlace(null)
        }
    }, [placeId]) // eslint-disable-line react-hooks/exhaustive-deps

    return [place, loading]
}

usePlace.propTypes = {
    placeId: PropTypes.string,
}

export default usePlace
